import $axios from "../../api";

const state = () => ({
    list: [],
    errors: [],
    viewData: {},
    isSuccess: false,
    isLoading: false,
    page: 1,
    types: [
      {
        id: 1,
        label: "Running Text",
        width: null,
      },
      {
        id: 2,
        label: "Desktop Home (2 - 737×300)",
        width: 1000,
      },
      {
        id: 14,
        label: "Desktop Bottom (14 - 367×150)",
        width: 1000,
      },
      {
        id: 7,
        label: "Desktop Clearance (7 - 1400×130)",
        width: 1400,
      },
      {
        id: 9,
        label: "Desktop Brandweek (9 - 1400×130)",
        width: 1400,
      },
      {
        id: 3,
        label: "Mobile Home (3 - 390×150)",
        width: 600,
      },
      {
        id: 16,
        label: "Mobile Mini Slider (16 - 180×150)",
        width: 600,
      },
      {
        id: 8,
        label: "Mobile Clearance (8 - 1400×130)",
        width: 600,
      },
      {
        id: 10,
        label: "Mobile Brandweek (10 - 1400×130)",
        width: 600,
      },
      {
        id: 11,
        label: "---Best Seller (11)",
        width: 500,
      },
      {
        id: 6,
        label: "---Flash Sale (6)",
        width: 400,
      },
      {
        id: 12,
        label: "---Featured (12)",
        width: 500,
      },
      {
        id: 13,
        label: "---New Products (13)",
        width: 500,
      },
      {
        id: 4,
        label: "---Side Top (4 - 367×145)",
        width: 500,
      },
      {
        id: 5,
        label: "---Side Bottom (5 - 367×145)",
        width: 500,
      },
      {
        id: 15,
        label: "---Subs VIP (15 - 555×225)",
        width: 500,
      },
      {
        id: 17,
        label: "---Desktop Header Article Blog (17 - 911×310)",
        width: 1300,
      },
      {
        id: 18,
        label: "---Desktop Middle Article Blog (18 - 1100×107)",
        width: 1300,
      },
      {
        id: 19,
        label: "---Mobile Header Article Blog (19 - 330×112)",
        width: 500,
      },
      {
        id: 20,
        label: "---Mobile Middle Article Blog (20 - 384×76)",
        width: 500,
      },
    ],
    
});

const mutations = {
  SET_IS_LOADING(state, data) {
    state.isLoading = data
  },
  SET_IS_SUCCESS(state, data) {
    state.isSuccess = data
  },
  SET_PAGE(state, data) {
    state.page = data
  },
  ASSIGN_LIST(state, data) {
    state.list = data;
  },
  ASSIGN_ERRORS(state, data) {
    state.errors = data
  },
  ASSIGN_VIEW_DATA(state, data) {
    state.viewData = data
  }
};

const actions = {
  fetchList({ commit, state, rootState, dispatch }, payload) {
    commit('SET_IS_LOADING', true);

    return new Promise((resolve, reject) => {
      $axios.get(`/website/slider-banner/list`, {
        params: {
          page: state.page,
          view: rootState.Main.view,
          ...payload,
        },
      })
        .then((response) => {
          commit('ASSIGN_LIST', response.data.data);
          resolve();
        })
        .catch((error) => {
          dispatch('Main/globalSweetAlert', error.response, {
            root: true,
          });

          reject(error);
        }).finally(() => {
          commit('SET_IS_LOADING', false);
        });
    });
  },
  create({ commit, state, rootState, dispatch }, payload) {
    commit('SET_IS_SUCCESS', false);
    commit('SET_IS_LOADING', true);

    return new Promise((resolve, reject) => {
      $axios.post(`/website/slider-banner/create`, payload)
        .then(() => {
          commit('SET_IS_SUCCESS', true);
          resolve();
        })
        .catch((error) => {
          if (error.response.status === 422) {
            commit('ASSIGN_ERRORS', error.response.data.errors);
          }
          dispatch('Main/globalSweetAlert', error.response, {
            root: true,
          });

          reject(error);
        }).finally(() => {
          commit('SET_IS_LOADING', false);
        });
    });
  },
  view({ commit, state, rootState, dispatch }, payload) {
    commit('SET_IS_LOADING', true);

    return new Promise((resolve, reject) => {
      $axios.get(`/website/slider-banner/view/${payload}`)
        .then((response) => {
          commit("ASSIGN_VIEW_DATA", response.data.data)
          resolve()
        })
        .catch((error) => {
          dispatch('Main/globalSweetAlert', error.response, {
            root: true,
          });

          reject(error);
        }).finally(() => {
          commit('SET_IS_LOADING', false);
        });
    });
  },
  update({ commit, state, rootState, dispatch }, payload) {
    commit('SET_IS_SUCCESS', false);
    commit('SET_IS_LOADING', true);

    return new Promise((resolve, reject) => {
      $axios.post(`/website/slider-banner/update/${payload?.id}`, payload?.data)
        .then(() => {
          commit('SET_IS_SUCCESS', true);
          resolve();
        })
        .catch((error) => {
          if (error.response.status === 422) {
            commit('ASSIGN_ERRORS', error.response.data.errors);
          }
          dispatch('Main/globalSweetAlert', error.response, {
            root: true,
          });

          reject(error);
        }).finally(() => {
          commit('SET_IS_LOADING', false);
        });
    });
  },
  showhide({ commit, state, rootState, dispatch }, payload) {
    commit('SET_IS_LOADING', true);

    return new Promise((resolve, reject) => {
      $axios.put(`/website/slider-banner/showhide/${payload}`)
        .then(() => {
          resolve();
        })
        .catch((error) => {
          dispatch('Main/globalSweetAlert', error.response, {
            root: true,
          });

          reject(error);
        }).finally(() => {
          commit('SET_IS_LOADING', false);
        });
    });
  },
  changePosition({ commit, state, rootState, dispatch }, payload) {
    commit('SET_IS_LOADING', true);

    return new Promise((resolve, reject) => {
      $axios.put(`/website/slider-banner/change-position/${payload.id}`, {
        sequence: payload.sequence,
      })
        .then(() => {
          resolve();
        })
        .catch((error) => {
          dispatch('Main/globalSweetAlert', error.response, {
            root: true,
          });

          reject(error);
        }).finally(() => {
          commit('SET_IS_LOADING', false);
        });
    });
  },
  delete({ commit, state, rootState, dispatch }, payload) {
    commit('SET_IS_LOADING', true);

    return new Promise((resolve, reject) => {
      $axios.delete(`/website/slider-banner/delete/${payload}`)
        .then(() => {
          resolve();
        })
        .catch((error) => {
          dispatch('Main/globalSweetAlert', error.response, {
            root: true,
          });

          reject(error);
        }).finally(() => {
          commit('SET_IS_LOADING', false);
        });
    });
  },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};